import {
    AfterContentInit,
    AfterViewInit,
    ChangeDetectorRef,
    Directive,
    ElementRef,
    Input,
    OnDestroy,
    OnInit
} from "@angular/core";
import {Subject, Subscription} from "rxjs";
import {FUIResponsiveService} from "@fedeltapointofsale/ui";

@Directive({
    selector: "[wbo-element-width]"
})
export class ElementWidthDirective implements OnInit, AfterViewInit, AfterContentInit, OnDestroy {
    @Input() changeSubject: Subject<void>;

    private subscriptions: Subscription = new Subscription();
    private elementWidth: number = undefined;
    private destroyed: boolean = false;

    constructor(private element: ElementRef,
                private changeDetectorRef: ChangeDetectorRef,
                private responsiveService: FUIResponsiveService) {
    }

    ngOnInit(): void {
        this.setElementWidthProperty();
        this.subscriptions.add(this.responsiveService.windowWidth$.subscribe(() => {
            this.setElementWidthProperty()
        }));
        if (this.changeSubject) {
            this.subscriptions.add(this.changeSubject.subscribe(() => {
                this.setElementWidthProperty()
            }));
        }
    }

    ngAfterViewInit(): void {
        this.setElementWidthProperty()
    }

    ngAfterContentInit(): void {
        this.setElementWidthProperty()
    }

    ngOnDestroy(): void {
        this.subscriptions.unsubscribe();
        this.destroyed = true;
    }

    private setElementWidthProperty(): void {
        setTimeout(() => {
            if (this.element && !this.destroyed) {
                const elementWidth: number = this.element.nativeElement.clientWidth;
                if (elementWidth !== this.elementWidth) {
                    this.elementWidth = elementWidth;
                    this.element.nativeElement.style.setProperty("--wbo-element-width", elementWidth);
                    this.changeDetectorRef.detectChanges();
                    this.responsiveService.emitWindowWidthChange();
                }
            }
        });
    }
}
